export default __webpack_public_path__ + "static/media/lock3.a792746b.svg";